import Vue from 'vue';
export default Vue.extend({
    methods: {
        $initChannel: function (channelName, params) {
            if (this.$waitingEventList) {
                this.$channel = this.$channelKeeper.retrieveChannel(channelName, params);
                for (var _i = 0, _a = Object.keys(this.$waitingEventList); _i < _a.length; _i++) {
                    var key = _a[_i];
                    var methodName = this.$waitingEventList[key];
                    this.$channel.on(key, this[methodName]);
                }
            }
        }
    },
    created: function () {
        // Phoenix is not exist in the options
        if (!this.$options.phoenix) {
            return;
        }
        this.$waitingEventList = {};
        for (var _i = 0, _a = Object.keys(this.$options.phoenix); _i < _a.length; _i++) {
            var key = _a[_i];
            var phoenixOption = this.$options.phoenix[key];
            if (typeof phoenixOption === 'string') {
                this.$channel ? this.$channel.on(key, this[phoenixOption]) : (this.$waitingEventList[key] = phoenixOption);
            }
            else {
                var channel = this.$channelKeeper.retrieveChannel(key);
                for (var _b = 0, _c = Object.keys(this.$options.phoenix[key]); _b < _c.length; _b++) {
                    var eventName = _c[_b];
                    var methodName = this.$options.phoenix[key][eventName];
                    channel.on(eventName, this[methodName]);
                }
            }
        }
    },
    destroyed: function () {
        // Phoenix is not exist in the options
        if (!this.$options.phoenix) {
            return;
        }
        for (var _i = 0, _a = Object.keys(this.$options.phoenix); _i < _a.length; _i++) {
            var key = _a[_i];
            var phoenixOption = this.$options.phoenix[key];
            if (phoenixOption instanceof Function) {
                if (this.$channel) {
                    this.$channel.off(key);
                }
            }
            else {
                var channel = this.$channelKeeper.retrieveChannel(key);
                for (var _b = 0, _c = Object.keys(this.$options.phoenix[key]); _b < _c.length; _b++) {
                    var eventName = _c[_b];
                    channel.off(eventName);
                }
            }
        }
    }
});
//# sourceMappingURL=mixin.js.map